// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app[data-v-dc54d426]{--bg-opacity:1;background-color:#fefeff;background-color:rgba(254,254,255,var(--bg-opacity))}", ""]);
// Exports
module.exports = exports;
